import {getPathLocales} from '../i18n/restrictedPaths'
import {routeTo} from '../router'

export enum QuestionsAndAnswersContentType {
  trademark = 'trademark',
  brandProtection = 'brand-protection',
}

export const questionsAndAnswersContentTypeToRoute = {
  [QuestionsAndAnswersContentType.trademark]: routeTo.trademarkQA,
  [QuestionsAndAnswersContentType.brandProtection]: routeTo.brandProtectionQA,
}

// The locales a Q&A is published in, as declared for the middleware in restrictedPaths.ts.
export const getQALocales = (type: QuestionsAndAnswersContentType) =>
  getPathLocales(questionsAndAnswersContentTypeToRoute[type].home())
